// =============================================================
// 首页内容数据（审美驱动的新零售）
// 目标行业：文创 / 饰品 / 潮玩 / 谷子 / 服装 / 珠宝 / 美妆 / 手作 / 杂货
// 目标人群：Z 世代、年轻女性、潮流 / 二次元 / IP 爱好者
// =============================================================

// 场景痛点区（4 场景，贴合审美零售经营）
export const painPoints = [
  {
    scene: '新品上架',
    pain: '款式多、上新快，手工录入又慢又容易错',
    solution: '智能条码录入、批量上货，新品秒上架',
    icon: 'tag',
  },
  {
    scene: '开单收银',
    pain: '高峰排队、颜色尺码易错、算错账',
    solution: '扫码开单、快捷收银，会员秒识别',
    icon: 'scan',
  },
  {
    scene: '库存管理',
    pain: '爆款缺货、积压款不知道，SKU 多难清',
    solution: '进销存一体化、低库存预警，补货有据',
    icon: 'box',
  },
  {
    scene: '经营报表',
    pain: '爆款/滞销看不清，陈列补货靠感觉',
    solution: '多维报表、经营数据分析，决策有数',
    icon: 'chart',
  },
]

// 功能亮点区（6 功能模块，贴合审美零售）
export const features = [
  { title: '轻松上货', desc: '条码即录，批量上架，新品快速入库', icon: 'tag' },
  { title: '智慧开单', desc: '扫码开单、快捷收银，款号颜色尺码不错', icon: 'scan' },
  { title: '库存管家', desc: '进销存一体化、库存预警，爆款不断货', icon: 'box' },
  { title: '精准报表', desc: '多维经营分析，爆款滞销一目了然', icon: 'chart' },
  { title: '会员营销', desc: '会员体系、充值、复购召回，私域促活', icon: 'user' },
  { title: '员工管理', desc: '员工权限、提成规则，多店协同管人', icon: 'team' },
]

// 移动端 / 小程序
export const mobileProduct = {
  app: {
    title: '掌上管店（App）',
    items: ['随时随地远程巡店', '经营数据 BI', '会员洞察', '远程管理'],
  },
  mini: {
    title: '专属小程序',
    items: ['微信一键开通', '会员自主下单', '微商城 24 小时不打烊', '虚拟导购'],
  },
}

// 客户案例 Logo（占位，需替换为真实授权 Logo）
export const clientBrands = [
  { name: '潮品會', tag: '潮玩' },
  { name: '玫瑰丽人', tag: '饰品' },
  { name: '锦绣女装', tag: '服装' },
  { name: '鸿达鞋服', tag: '服装' },
  { name: '衣见钟情', tag: '服装' },
  { name: '百利甜', tag: '美妆' },
  { name: '一个女孩', tag: '杂货' },
  { name: '乐其依生', tag: '文创' },
  { name: 'TW·柚见', tag: '手作' },
]

// 数据与信任背书（示例值，待确认真实数据）
export const stats = [
  { value: 20, suffix: 'W+', label: '服务门店' },
  { value: 7, suffix: '×16h', label: '企业级服务' },
  { value: 34, suffix: '省+', label: '门店覆盖省级行政区' },
  { value: 1000, suffix: '万+', label: '月均交易笔数' },
]



// WEBPACK FOOTER //
// ./src/site/data/homeContent.js